// extracted by mini-css-extract-plugin
export default {"snackbarCenter":"ContactsInfomation_snackbarCenter__QfIa+"};